import { render } from "./Detail.vue?vue&type=template&id=ab091918&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=ab091918&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab091918"]])

export default __exports__